<template>
<form name="register_form" style="min-height: 100vh">
    <!-- Register -->
    <div id="register" v-if="isMain">
        <div id="wrap">
            <div class="reg-logo"><img src="~@/assets/images/logo.svg"></div>

            <div class="reg1-1">
                Greed Greed へようこそ<br>
                通話からはじまる<br>
                高品質な出会いをお楽しみください<br>
            </div>
            <div class="btn1"><a @click="openPersional">はじめる</a></div>
            <div class="btn2"><a @click="goToLogin()">アカウントをお持ちの方は<span class="reg1-2">ログイン</span></a></div>
            <div class="reg1-3">※18歳未満の方はご利用できません</div>
            <div class="reg1-4 mycheckbox"><input v-model="isAgree" checked id="sample" type="checkbox"><label for="sample"></label>登録すると同時に、私は
                <a @click="$router.push({name: 'otherPage', query: {site_name: 'terms_of_use'}})" class="a-page">利用規約</a>と
                <a @click="$router.push({name: 'otherPage', query: {site_name: 'privacy_policy'}})" class="a-page">プライバシーポリシー</a>に同意します。
            </div>
        </div>
    </div>

    <div v-else>
        <!-- Register 1 - persional infomation -->
        <persionalInfo @close="closePersional" @next="nextPersional" :dataPersional="dataPersional" :isShow="isRegisterPersionalInfo"></persionalInfo>
        <!-- phone nummber -->
        <phoneNumber @submitVerifyPhone="submitVerifyPhone" :isVerifyPhone="isVerifyPhone" v-if="isShowPhoneNumber" :isShow="isShowPhoneNumber" :phoneData="dataPhone" @close="closePhone" @submit="submitAndRegisterPhone" @changePhone="changePhone"></phoneNumber>
        <!-- Profile register -->
        <question v-if="isQuestion" :isShow="isQuestion" @submit="updateUser"></question>
    </div>

</form>
<alertDialog :active="isAlert" @close="isAlert = false">
    <div>{{ alertMessage}}</div>
</alertDialog>
<div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>

<a id="p-ber-click" href="" onclick="wdlogin.init(this); return false;"></a>
</template>

<script>
import CONSTANTS from '@/constants'
import {
    mapGetters,
    mapActions
} from 'vuex'
import {
    setStepRegister,
    getVerifyPhone,
    getStepRegister,
    setVerifyPhone,
    setLoginBonus,
    setLoginDayNumber
} from '@/auth'
import persionalInfo from './component/persionalInfo'
import phoneNumber from './component/phoneNumber'
import question from './component/question'
import mixin from '@/mixin'
import alertDialog from '@/views/components/alertDialog'

export default {
    components: {
        persionalInfo,
        phoneNumber,
        question,
        alertDialog
    },
    mixins: [mixin],
    data: () => ({
        is_register_persional_info: 0, // 0: not register, 1: registerd
        next_part: 'job',
        formProfileRegister: [],
        dayOfMonth: 31,
        formData: null,
        dataPersional: null,
        dataPhone: null,
        isRegisterPersionalInfo: false,
        isMain: true,
        isShowPhoneNumber: false,
        isVerifyPhone: false,
        isQuestion: false,
        questionData: null,
        isAlert: false,
        alertMessage: null,
        isAgree: true,
        isLoading: false
    }),
    watch: {
        isMain(val) {
            if (val) {
                setTimeout(() => {
                    window.scrollTo(0, 0)
                }, 10)
            }
        },
        isShowPhoneNumber() {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 10)
        }
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken', 'userDetail']),
    },
    beforeMount() {

    },

    async mounted() {
        // Setup for p-ber Start
        let script = document.createElement("script");
        script.src = 'https://www.gstatic.com/firebasejs/7.16.1/firebase-app.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.src = 'https://www.gstatic.com/firebasejs/7.16.1/firebase-messaging.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = CONSTANTS.PUSH_SYS_URL + 'wdlogin.js';
        document.head.appendChild(script);

        script = document.createElement("script");
        script.innerHTML = 'var WD_CONFIG = { app_code: "' + CONSTANTS.PUSH_APP_CODE + '", app_key: "' + CONSTANTS.PUSH_APP_KEY + '" };';
        document.head.appendChild(script);
        // Setup for p-ber End

        if (parseInt(this.$route.query.is_main) === 1) {
            this.isMain = false
            this.isRegisterPersionalInfo = true
        }
        this.$store.dispatch("route/showLoading")
        if (parseInt(getStepRegister()) == CONSTANTS.STEP_REGISTER_UPDATE_INFO) {
            if (parseInt(getVerifyPhone()) !== CONSTANTS.IS_VERIFY_PHONE_NUMBER) {
                this.isShowPhoneNumber = true
                this.isVerifyPhone = true
                await this.userProfile({
                    token: this.defaultToken
                })

                this.dataPhone = {
                    phone: this.userDetail.phone
                }
                // console.log('data phone: ', this.dataPhone)
                this.isMain = false
            } else {

                this.isQuestion = true
                this.isMain = false
            }
        }
        this.$store.dispatch("route/hideLoading")
    },
    methods: {
        ...mapActions({
            userProfile: 'user/userProfile'
        }),
        openPersional() {
            if (!this.isAgree) {
                
                this.isAlert = true
                this.alertMessage = "利用規約とブライバシーボリシーに同意する必要があります。"
                return
            }
            this.isRegisterPersionalInfo = true
            this.isMain = false
        },
        closePersional(formData) {
            this.isRegisterPersionalInfo = false,
            this.isMain = true
            this.$router.replace({name: 'register'})
        },
        nextPersional(formData) {
            this.dataPersional = formData
            if (!this.formData) {
                this.formData = {}
            }
            this.formData = Object.assign(this.formData, this.dataPersional)
            this.isRegisterPersionalInfo = false
            this.isMain = false
            this.isShowPhoneNumber = true // Open phone number form
        },
        closePhone(formData) {
            this.isShowPhoneNumber = false
            this.isRegisterPersionalInfo = true
            this.dataPhone = formData
        },
        changePhone(formData) {
            this.dataPhone = formData
        },
        submitVerifyPhone() {
            this.isShowPhoneNumber = false
            this.isQuestion = true
        },
        async submitAndRegisterPhone(formData) {
            this.$store.dispatch("route/showLoading")
            if (!this.formData) {
                this.formData = {}
            }
            this.formData = Object.assign(this.formData, formData)
            let form = new FormData()
            form.append('token', this.defaultToken)
            form.append('birthday', this.formData.birthday_year + '-' + this.formData.birthday_month + '-' + this.formData.birthday_day)
            let asArray = Object.entries(this.formData);
            asArray.forEach(item => {
                form.append(item[0], item[1])
            })
            await this.getTokenFirebase()
            await this.$store.dispatch('register/doRegister', form).then(async data => {
                if (data.user_code) {
                    this.isVerifyPhone = true
                    setStepRegister(CONSTANTS.STEP_REGISTER_UPDATE_INFO)
                    setVerifyPhone(0)
                    await this.userProfile({
                        token: this.defaultToken
                    })
                    setLoginBonus(this.userDetail.is_bonus)
                    setLoginDayNumber(this.userDetail.login_days_number)
                } else {
                    this.isAlert = true
                    this.alertMessage = "Register fail"
                }
            }).catch(err => {
                this.isVerifyPhone = false
                if (err.response != undefined) {
                    this.isAlert = true
                    this.alertMessage = err.response.data.message
                }
                console.log(err);
            })
            this.$store.dispatch("route/hideLoading")
        },

        goToLogin() {
            if (!this.isAgree) {
                this.isAlert = true
                this.alertMessage = "利用規約とブライバシーボリシーに同意する必要があります。"
                return
            }
            this.$router.push({
                name: 'login'
            })
        },

        async updateUser(form) {
            this.isLoading = true
            let formData = new FormData();
            formData.append('token', this.defaultToken)
            let asArray = Object.entries(form);
            asArray.forEach(item => {
                formData.append(item[0], item[1])
            })
            await this.$store.dispatch('user/userUpdate', formData).then(async (data) => {
                this.remRegistQuestionSession()

                setStepRegister(CONSTANTS.STEP_REGISTER_DONE)
                await this.userProfile({
                    token: this.defaultToken
                })

                const userAgent = navigator.userAgent;
                if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
                    document.getElementById('p-ber-click').setAttribute('data-user-id', data.id);
                    document.getElementById('p-ber-click').click()
                    return
                }

                await this.$router.push({
                    name: 'home'
                });
            }).catch(err => {
                console.log(err);
            });
            this.isLoading = false
        },

    },
}
</script>

<style scoped>
.a-page {
    text-decoration-line: underline;
}

.a-page:hover {
    text-decoration-line: none;
}
.reg1-4.mycheckbox label {
    padding-left: 0px;
    margin-right: 28px;
}
.loading-screen {
    /* background: rgba(94, 94, 94, 0.185) */
    opacity: 0.6;
}
</style>
